import { COMMOM_STATUS, EXPORT_TYPE, orderStatusFormatted, PRINT_SIZE } from "src/constant";
import useOrderPreview from "src/hooks/orders/useOrderPreview";
import DeliveredReceipt from "src/pages/orders/all-order/export-form/DeliveredReceipt";
import { Button, DialogActions, DialogContent, Skeleton } from "@mui/material";
import { useState } from "react";
import useProcessLogDetail from "src/hooks/process-log/useProcessLogDetail";
import useWarehouseTransferExport from "src/hooks/warehouse-transfer/useWarehouseTranferExport";
import appConfig from "src/config/env";
import { enqueueSnackbar } from "notistack";
import useOrderPrint from "src/hooks/orders/useOrderPrint";

export default function DebtSalesPrintDialog({ item, type = "Exported", outputFile = EXPORT_TYPE.WarehouseExport }) {
  const [logId, setLogId] = useState(null);
  const { mutate } = useProcessLogDetail(logId);
  const { trigger: printWT } = useWarehouseTransferExport();
  const { trigger: printOrder } = useOrderPrint();
  const { data: orderPreview, isLoading } = useOrderPreview(item?.contextId, {
    warehouse: item?.warehouse?._id,
    outputFile: outputFile,
    type: type,
  });

  const handleGetLog = (logIdParam) => {
    const logIdToUse = logIdParam || logId;
    if (!logIdToUse) return;

    const timeOut = setInterval(async () => {
      try {
        const res = await mutate();
        if (res?.success) {
          if (res.data.status === COMMOM_STATUS.done) {
            if (Array.isArray(res.data?.urls)) {
              res.data.urls.forEach((v) => {
                window.open(`${appConfig.API_FILE}/${v}`, "_blank");
              });
            }
            clearInterval(timeOut);
          }

          if (res.data.status === COMMOM_STATUS.error) {
            enqueueSnackbar("Không xuất được đơn", { variant: "error" });
            clearInterval(timeOut);
          }
        }
      } catch (err) {
        clearInterval(timeOut);
      }
    }, 1000);
  };

  const handlePrint = async () => {
    const res = await printOrder({
      body: {
        orderIds: [item?.contextId || item?._id],
        pageSize: PRINT_SIZE.a6,
        warehouse: item?.warehouse?._id || item?.warehouse,
        outputFiles: [outputFile],
      },
    });
    if (res?.success) {
      setLogId(res?.data?._id);
      handleGetLog(res?.data?._id);
      return enqueueSnackbar("Tiến hành xuất phiếu...", { variant: "success", className: 'notistack-confirm' });
    } else {
      return enqueueSnackbar(res?.error?.message ?? res?.error?.message, {
        variant: "error",
      });
    }
  };

  return (
    <>
      <DialogContent sx={{ overflowY: "auto", pb: "48px" }}>
        {isLoading ? (
          Array.from({ length: 10 }, (_, i) => {
            return (
              <Skeleton
                key={i}
                width="100%"
                height="44px"
              />
            );
          })
        ) : (
          <DeliveredReceipt
            isLoading={isLoading}
            html={orderPreview}
          />
        )}
      </DialogContent>
      <DialogActions sx={{ p: "0px 12px 24px" }}>
        <Button
          onClick={handlePrint}
          fullWidth
          variant="contained"
        >
          In phiếu
        </Button>
      </DialogActions>
    </>
  );
}
